export default __webpack_public_path__ + "static/media/9.caf9593c.jpg";